import { useState, useEffect, memo } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import classes from "./ConfirmModal.module.scss";
import DialogButton from "../DialogButton";
import PrimaryButton from "../PrimaryButton";

const style = {
  box: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
      xs: 320, // 0px以上の幅で360pxを適用
      sm: 360, // 600px以上の幅で400pxを適用
    },
    //width: 300,
    bgcolor: "background.paper",
    border: "none",
    borderRadius: "10px",
    boxShadow: 24,
    padding: "20px 0",
  },

  iconImage: {
    color: "error.main",
    marginTop: 0.5,
  },
  title: {
    color: "error.main",
  },
  message: {
    marginTop: "20px",
    marginLeft: "20px",
    marginBottom: "20px",
  },
};

export const JumpModal = memo((props) => {
  const { title, message, setIsShow, onExec, buttonLabel } = props;
  const [open, setOpen] = useState(true);
  const handleClose = () => {
    setIsShow(false);
    setOpen(false);
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style.box} onClick={handleClose}>
          <div className={classes.root}>
            <div className={classes.titleContainer}>
              <div>
                <ErrorOutlineIcon sx={style.iconImage} />
              </div>
              <div>
                <Typography
                  id="modal-modal-title"
                  sx={style.title}
                  variant="h6"
                  component="h2"
                >
                  {title}
                </Typography>
              </div>
            </div>
            <div className="module-spacer--extra-small" />
            <Typography id="modal-modal-description" sx={style.message}>
              {message}
            </Typography>
            <div className="module-spacer--small" />
            <div className={classes.buttons}>
              <PrimaryButton label={buttonLabel} onClick={onExec} />
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
});
